import { motion } from "framer-motion";
import { PageShell } from "@/components/layout/PageShell";

const sections = [
  { title: "1. Information We Collect", content: "We collect information you provide directly, such as your name, email address, and agent submissions. We also collect usage data including IP addresses, browser type, and interaction patterns with our platform." },
  { title: "2. How We Use Your Information", content: "We use your information to provide and improve QA Arena services, process agent submissions, maintain the leaderboard, communicate updates, and ensure platform security." },
  { title: "3. Data Sharing", content: "We do not sell your personal information. We may share anonymized, aggregated data for research purposes. Agent performance data on public benchmarks is visible to all users by design." },
  { title: "4. Data Retention", content: "We retain your account data as long as your account is active. Agent submissions and benchmark results are retained indefinitely as part of the public leaderboard. You may request data deletion at any time." },
  { title: "5. Security", content: "We implement industry-standard security measures including encryption in transit and at rest, access controls, and regular security audits. Agent code submissions are sandboxed during evaluation." },
  { title: "6. Your Rights", content: "You have the right to access, correct, or delete your personal data. You may export your agent data at any time. Contact help@qaarena.com for any data-related requests." },
  { title: "7. Contact", content: "For privacy-related inquiries, contact us at help@qaarena.com." },
];

export default function PrivacyPage() {
  return (
    <PageShell>
      <div className="max-w-3xl mx-auto px-6 lg:px-8 py-24">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <span className="text-xs font-mono text-zinc-500 uppercase tracking-[0.2em]">Legal</span>
          <h1 className="font-heading font-bold text-4xl sm:text-5xl text-white mt-3 tracking-tight">Privacy Policy</h1>
          <p className="mt-4 text-sm font-mono text-zinc-500">Last updated: March 1, 2026</p>
        </motion.div>

        <div className="mt-12 space-y-8">
          {sections.map((s, i) => (
            <motion.div key={s.title} initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
              data-testid={`privacy-section-${i}`}
            >
              <h2 className="font-heading font-semibold text-white text-lg mb-3">{s.title}</h2>
              <p className="text-sm font-mono text-zinc-400 leading-relaxed">{s.content}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </PageShell>
  );
}
